var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: class-name */
/*
 * AUTOGENERATED FILE - DO NOT EDIT
 */
import { ewJSONHourVisit } from './ewJSONHourVisit';
import { JSONStruct, nullable_array_property, property } from 'badphraim/data/JSONStruct';
export class ewJSONDayVisit extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.dayno = 0;
        /** @override */ this.long = '';
        /** @override */ this.short = '';
    }
}
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONDayVisit.prototype, "dayno", void 0);
__decorate([
    nullable_array_property(ewJSONHourVisit),
    __metadata("design:type", Array)
], ewJSONDayVisit.prototype, "hours", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewJSONDayVisit.prototype, "long", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewJSONDayVisit.prototype, "short", void 0);
